import { Company } from "../models/company";
import { CompanyProfileInitial } from "./enums";
import { isCompanyProfile } from "./validation";

export const formatPhoneNumber = (phoneNumber?: string) => {
  if (!phoneNumber) return "";

  return phoneNumber;
};

export const phoneNumberHasLetters = (phonenumber: string) => {
  if (!phonenumber) return false;

  const regex = /[a-zA-Z]+$/;

  return regex.test(phonenumber);
};

const hasAllChars = (phoneNumber: string, availableCharacters: string[]) => {
  const availableCharactersSet = new Set(availableCharacters);

  const onlyNumbers = /^\d+$/;

  for (const char of phoneNumber) {
    if (!availableCharactersSet.has(char) && !onlyNumbers.test(char)) {
      return false;
    }
  }

  return true;
};

export const phoneNumberIsValid = (phoneNumber: string) => {
  if (phoneNumber === undefined || phoneNumber === null) return false;

  if (phoneNumberHasLetters(phoneNumber)) return false;

  const availableCharacters = ["+", "-", "(", ")"];

  return hasAllChars(phoneNumber, availableCharacters);
};

export const phoneInputSettings = (company?: Company, defaultCountry?: boolean) => {
  if (isCompanyProfile(company, CompanyProfileInitial.MV)) {
    return {
      withoutFormat: true,
    };
  }

  return {
    international: true,
    defaultCountry: defaultCountry ? "" : "AU",
  };
};
